// Central PostHog analytics helper.
// PostHog is initialised in public/index.html — this module wraps
// window.posthog.capture with safe defaults so we can rename / disable
// tracking in one place.

const isBrowser = typeof window !== "undefined";

function safeCapture(event, props = {}) {
  if (!isBrowser) return;
  try {
    if (window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(event, props);
    }
  } catch (_e) {
    // Never let analytics take down a user flow.
  }
}

// ---- Named events (kept flat + snake_case for easy funnel queries) ----

export const trackBookingSubmitted = (data = {}) =>
  safeCapture("booking_submitted", {
    role: data.role || null,
    has_date: Boolean(data.date),
    has_time: Boolean(data.time),
    has_message: Boolean(data.message),
  });

export const trackSampleRequested = (data = {}) =>
  safeCapture("sample_requested", {
    role: data.role || null,
    material_count: Array.isArray(data.materials) ? data.materials.length : 0,
    product_count: Array.isArray(data.products) ? data.products.length : 0,
  });

export const trackContactSubmitted = (data = {}) =>
  safeCapture("contact_submitted", {
    message_len: (data.message || "").length,
  });

export const trackGuideDownload = (data = {}) =>
  safeCapture("guide_downloaded", {
    guide_slug: data.guide_slug || null,
    element: data.element || null,
    has_company: Boolean(data.company),
  });

export const trackRoomShared = (data = {}) =>
  safeCapture("room_shared", { room: data.room || null, spec: data.spec || null });

export const trackVisualiserChange = (props = {}) =>
  safeCapture("visualiser_used", {
    room: props.room || null,
    product_id: props.productId || null,
    colour_idx: props.colourIdx ?? null,
    joinery: props.joinery || null,
  });

export const trackProductViewed = (product) =>
  safeCapture("product_viewed", {
    product_id: product?.id || null,
    product_name: product?.name || null,
    discipline: product?.discipline || null,
  });

export const trackAdminLogin = () => safeCapture("admin_login");

export const trackDialogOpen = (which) => safeCapture("dialog_open", { which });
